import { actionCreator, checkHttpStatus, jsonApiHeader, showSuccessMessage, showWarningMessage } from "../../downLoadClientList/constants/ApiConstants"
import { DownloadTargetActionTypes, POST_UPLOADNEWTARGETS, POST_UPLOADNEWBEHAVIORS, POST_DOWNLOADBEHAVIORSFORRAWDATA, GET_CLIENTSFORBEHAVIORDOWNLOAD, GET_BEHAVIORSBYCLIENTIDS } from '../constants/ApiConstants';
import { createRequestAction } from '../../../../../../actions/utilAction';

// export const uploadNewTargets = createRequestAction(DownloadTargetActionTypes.post_UploadNewTargets, POST_UPLOADNEWTARGETS, 'POST');
// export const uploadNewBehaviors = createRequestAction(DownloadTargetActionTypes.post_UploadNewBehaviors, POST_UPLOADNEWBEHAVIORS, 'POST');

export const uploadNewTargets = (UploadFile) => {
    return (dispatch,getState) => {
        dispatch(actionCreator(DownloadTargetActionTypes.post_UploadNewTargets.REQUEST));
        fetch(`${POST_UPLOADNEWTARGETS}`, {
             method: 'post',
             headers: jsonApiHeader(getState().login.access_token, 'application/json'),
             body: JSON.stringify(UploadFile),
           })
             .then(checkHttpStatus)
             .then(function(response) {        
               if (response.statusCode === 200) {
                 showSuccessMessage(response.message);
               } else if (response.statusCode === 422) {
                 showWarningMessage(response.message);
               } else {
                 dispatch(actionCreator(DownloadTargetActionTypes.post_UploadNewTargets.FAILURE, response.message));
                 //showErrorMessage(response.message);
               }      
             })
             .catch(function(error) {
               console.log('error-----', error);
             });
    }
}

export const uploadBehavior = (UploadFile) => {
    return (dispatch,getState) => {
        dispatch(actionCreator(DownloadTargetActionTypes.post_UploadNewBehaviors.REQUEST));
        fetch(`${POST_UPLOADNEWBEHAVIORS}`, {
             method: 'post',
             headers: jsonApiHeader(getState().login.access_token, 'application/json'),
             body: JSON.stringify(UploadFile),
           })
             .then(checkHttpStatus)
             .then(function(response) {        
               if (response.statusCode === 200) {
                 showSuccessMessage(response.message);
               } else if (response.statusCode === 422) {
                 showWarningMessage(response.message);
               } else {
                 dispatch(actionCreator(DownloadTargetActionTypes.post_UploadNewBehaviors.FAILURE, response.message));
                 //showErrorMessage(response.message);
               }      
             })
             .catch(function(error) {
               console.log('error-----', error);
             });
    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargets/actions/downloadTargetAction.js